import React, { Component } from "react";
import AccountItem from "Molecules/AccountItem";
import Currency from "react-currency-formatter";
import * as _ from 'lodash';


export default class AccountsList extends Component {
	constructor(props){
		super(props);
		this.getList = this.getList.bind(this);
	}


	openPayModal = accountNumber => {
		window._satellite.track('accountnumber');
		this.props.showPayModalFunc();
		this.props.openPayModalFunc(accountNumber);
	};

	showPayVeilHandler = () => {
		this.props.showPayVeilFunc();
	};

	hidePayVeilHandler = () => {
		this.props.hidePayVeilFunc();
	};

	getList() {
		const listItems = [];
		let i = 0;
		_.forOwn(this.props.accounts, (accountData) => {
			listItems.push(
				<AccountItem
					key={i}
					index={i}
					accountData={accountData}
					openPayModal={this.openPayModal}
					showPayVeil={this.showPayVeilHandler}
					hidePayVeil={this.hidePayVeilHandler}
					mobileViewToggle={this.props.mobileViewToggle}
				/>
			);
			i++;
		});
		return listItems;

	};
	render() {
		return (
			<div className="billing-accounts-list">
				{this.getList()}
				<div className="billing-accounts-total">
					<div className="dx-col">
						<ul>
							<li>Total</li>
							<li>
								<Currency
									quantity={parseFloat(this.props.total_amount)}
									pattern="!#,##0.00"
								/>
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atomic/pages/AccountsPage/children/AccountsList.js